export default "__VITE_ASSET__qgV0pwMh__"